import { render, staticRenderFns } from "./InvestmentFailure.vue?vue&type=template&id=07e87dff&scoped=true"
import script from "./InvestmentFailure.vue?vue&type=script&lang=js"
export * from "./InvestmentFailure.vue?vue&type=script&lang=js"
import style0 from "./InvestmentFailure.vue?vue&type=style&index=0&id=07e87dff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e87dff",
  null
  
)

export default component.exports